import { db } from '../firebase';
import { 
  collection, 
  addDoc, 
  query, 
  where, 
  getDocs,
  updateDoc,
  deleteDoc,
  doc 
} from 'firebase/firestore';

export const createBudget = async (userId, budgetData) => {
  return await addDoc(collection(db, 'budgets'), {
    userId,
    ...budgetData,
    createdAt: new Date()
  });
};

export const getBudgets = async (userId) => {
  const q = query(collection(db, 'budgets'), where('userId', '==', userId));
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};

export const updateBudget = async (budgetId, data) => {
  const budgetRef = doc(db, 'budgets', budgetId);
  return await updateDoc(budgetRef, data);
};

export const deleteBudget = async (budgetId) => {
  return await deleteDoc(doc(db, 'budgets', budgetId));
};
